import { render, staticRenderFns } from "./l-examen.html?vue&type=template&id=f40a1acc&scoped=true&external"
import script from "./l-examen.js?vue&type=script&lang=js&external"
export * from "./l-examen.js?vue&type=script&lang=js&external"
import style0 from "./l-examen.scss?vue&type=style&index=0&id=f40a1acc&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f40a1acc",
  null
  
)

export default component.exports